<template>
  <Section
    class="w-full"
    :title="title"
    :icon="isOpen ? MdiUnfoldLessHorizontal : MdiUnfoldMoreHorizontal"
    @headerClick="isOpen = !isOpen"
    clickable
    :expanded="isOpen"
    :class="$attrs.class"
  >
    <slot v-if="isOpen"></slot>
  </Section>
</template>
<script setup lang="ts">
import Section from "./Section.vue";
import MdiUnfoldMoreHorizontal from "~icons/mdi/unfold-more-horizontal";
import MdiUnfoldLessHorizontal from "~icons/mdi/unfold-less-horizontal";
import { ref } from "vue";

defineProps<{
  title: string;
}>();

const isOpen = ref(false);
</script>
